import React, { useState, useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import globals from "../globals.js";
import { getCookies } from "../controllers/cookies.controller";

import Header from "../components/Header";

import planLivreImg from "../img/2k20-livre.svg";
import planTotalImg from "../img/2k20-total.svg";
import planMovelImg from "../img/2kmovel-logo.svg";

import combateImg from "../img/canais/combate.svg";
import hboImg from "../img/canais/hbo.svg";
import playboyImg from "../img/canais/playboy.svg";
import premiereImg from "../img/canais/premiere.svg";
import sexhotImg from "../img/canais/sexhot.svg";
import sexpriveImg from "../img/canais/sexprive.svg";
import telecineImg from "../img/canais/telecine.svg";
import venusImg from "../img/canais/venus.svg";

import "../styles/plans.css";

// Assuming ApiPlan structure based on context
interface ApiPlan {
    id: number | string;
    id_plano: number | string;
    nome: string;
    valor: number;
    tipo_pessoa: 'T' | 'PF' | 'PJ';
    serv_ad: ServAd[];
    caracteristicas: string[]; // Assuming benefits come as an array of strings
    categoria: string; // Expecting a category field from API
    tipo_plano: string; // e.g., 'INTERNET', 'STREAMING', 'TELEFONIA_MOVEL', 'TELEFONIA_FIXA'
}

interface ServAd {
    id: number | string;
    id_plano: number | string;
    nome: string;
    valor: number;
}

type ApiResponse = {
    status: string;
    contrato_id?: number | string;
    msg?: string;
};

type LaCarteChannel = {
    name: string;
    price: number;
    img: string;
};





const Plans = () => {

    const [plansStreaming, setPlansStreaming] = useState<ApiPlan[]>([]);
    const [plansTelefoniaMovel, setPlansTelefoniaMovel] = useState<ApiPlan[]>([]);
    const [plansTelefoniaFixa, setPlansTelefoniaFixa] = useState<ApiPlan[]>([]);
    const [selectedStreaming, setSelectedStreaming] = useState<ApiPlan | null>(null);
    const [selectedMovel, setSelectedMovel] = useState<ApiPlan | null>(null);
    const [selectedFixa, setSelectedFixa] = useState<ApiPlan | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isPJ, setIsPJ] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const fetchPlans = useCallback(async () => {
        const searchParams = new URLSearchParams(location.search);
        const regiaoFromUrl = searchParams.get('regiao');

        // const dt_get_plano: { route: string; data: { regiao?: string } } = {
        //     route: "get_plano",
        //     data: {}
        // };

        // if (regiaoFromUrl) {
        //     dt_get_plano.data['regiao'] = regiaoFromUrl;
        // }

        try {
            
            let fetch_url = `${globals.apiBaseUrl}/api/contratoonline/planos`;
            if (regiaoFromUrl) {
                fetch_url += `?regiao=${regiaoFromUrl}`;
            }
            const response = await fetch(fetch_url, {
                method: 'get',
            });

            if (!response.ok) {
                throw new Error('Failed to fetch plans');
            }

            const dt_plano = await response.json();
            const allPlans: ApiPlan[] = dt_plano.plano || [];
            //console.log(allPlans);
            setPlansStreaming([]);
            setPlansTelefoniaMovel([]);
            setPlansTelefoniaFixa([]);

            const streaming: ApiPlan[] = [];
            const movel: ApiPlan[] = [];
            const fixa: ApiPlan[] = [];

            for (const plan of allPlans) {
                if (plan.tipo_plano === 'STREAMING') {
                    streaming.push(plan);
                } else if (plan.tipo_plano === 'TELEFONIA_MOVEL') {
                    movel.push(plan);
                } else if (plan.tipo_plano === 'TELEFONIA_FIXA') {
                    fixa.push(plan);
                }
            }

            setPlansStreaming(streaming);
            setPlansTelefoniaMovel(movel);
            setPlansTelefoniaFixa(fixa);

            // setPlans(allPlans);

            // const personalDataCookie = getCookies("personalData");
            // const personalData = personalDataCookie ? JSON.parse(personalDataCookie) : null;
            // const tipoPessoa = personalData?.tipo_pessoa;

            // if (tipoPessoa) {
            //     const filteredPlans = allPlans.filter(plan => plan.tipo_pessoa === tipoPessoa || plan.tipo_pessoa === 'T');
            //     setPlans(filteredPlans);
            // } else {
            //     setPlans(allPlans);
            // }
            // Not implemented from user snippet: pre-selecting plan, servicosAdicionais
        } catch (error) {
            console.error("Error fetching plans:", error);
        }
    }, [location.search]);

    useEffect(() => {
        fetchPlans();
    }, [fetchPlans]);

    useEffect(() => {
        const fetchUserType = async () => {
            const token = getCookies('token');
            if (!token) return;
            try {
                const response = await fetch(`${globals.apiBaseUrl}/api/contratoonline/user`, {
                    method: 'GET',
                    headers: { 'Authorization': token },
                });
                const data = await response.json();
                if (data.status === 'sucess' && data.user?.cpf_cnpj) {
                    const cleaned = data.user.cpf_cnpj.replace(/\D/g, '');
                    setIsPJ(cleaned.length === 14);
                }
            } catch (error) {
                console.error("Erro ao buscar tipo de usuário:", error);
            }
        };
        fetchUserType();
    }, []);




    // Handlers para seleção de planos - automaticamente redireciona para pagamento
    const handleSelectStreaming = async (plan: ApiPlan) => {
        setSelectedStreaming(plan);
        setSelectedMovel(null);
        setSelectedFixa(null);
        await processPayment(plan.id_plano);
    };

    const handleSelectMovel = async (plan: ApiPlan) => {
        setSelectedMovel(plan);
        setSelectedStreaming(null);
        setSelectedFixa(null);
        await processPayment(plan.id_plano);
    };

    const handleSelectFixa = async (plan: ApiPlan) => {
        setSelectedFixa(plan);
        setSelectedStreaming(null);
        setSelectedMovel(null);
        await processPayment(plan.id_plano);
    };

    // const handleSelectLaCarte = (channel: LaCarteChannel) => {
    //     setSelectedLaCarte(prev => {
    //         if (prev.find(c => c.nome === channel.nome)) {
    //             return prev.filter(c => c.nome !== channel.nome);
    //         } else {
    //             return [...prev, channel];
    //         }
    //     });
    // };


    const processPayment = async (id_plano: number | string) => {
        setIsLoading(true);
        try {
            const response = await fetch(`${globals.apiBaseUrl}/api/contratoonline/planos`, {
                method: "POST",
                headers: {
                    'Authorization': getCookies('token') || '',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    plano: id_plano,
                }),
            });

            const result: ApiResponse = await response.json();

            if (!response.ok || result.status !== 'sucess') {
                throw new Error(result.msg || "Falha ao processar o plano.");
            }

            const planData = {
                contrato_id: result.contrato_id,
                plano: id_plano,
                servico_adicional: [],
            };

            navigate('/pagamento', { state: planData });
        } catch (error: any) {
            console.error("Erro ao processar plano:", error);
            alert(error.message || "Ocorreu um erro ao processar o plano.");
        } finally {
            setIsLoading(false);
        }
    };



    return (
        <React.Fragment>
            {isLoading && (
                <div className="loading-modal-overlay">
                    <div className="loading-modal">
                        <div className="loading-spinner"></div>
                        <p>Processando seu plano...</p>
                    </div>
                </div>
            )}
            <Header />
            {(
                <>
                    {!isPJ && (
                    <div className="plans-container">
                        <div className="plans-header">
                            <b>Escolha o Plano Ideal para você<br />na 2k20 Streaming!</b>
                            <span>Aproveite a melhor programação ao vivo, seus canais locais favoritos e uma vasta biblioteca de filmes e séries para assistir quando quiser.<br />Liberdade e entretenimento sob medida para você!</span>
                        </div>
                        <div className="plans-grid">
                            {plansStreaming.map((p) => {
                                const [precoInt, precoDec] = p.valor.toFixed(2).split(".");
                                const className = p.nome.includes('Total') || p.nome.includes('15GB') || p.nome.includes('30GB') || p.nome.includes('50GB') || p.nome.includes('Mais') ? 'purple' : '';

                                return (
                                    <div className={`plan-element ${className}`} key={p.nome}>
                                        <img src={p.nome === "Plano Livre" ? planLivreImg : planTotalImg} className="plan-logo" alt="plan logo" />
                                        <div className="price-wrapper">
                                            <span>R$</span>
                                            <span className="price-dest">{precoInt}</span>
                                            <span className="price-small">,{precoDec}</span>
                                            <span className="month">/mês</span>
                                        </div>

                                        <div className="benefits-wrapper">
                                            {p.serv_ad.map((b) => (
                                                <div className="benefit-row" key={b.nome}><span>{b.nome}</span></div>
                                            ))}
                                        </div>

                                        <div className="button-wrapper">
                                            <button
                                                className="streaming-plans-button"
                                                data-plan-name={p.nome}
                                                data-plan-price={precoInt}
                                                onClick={() => handleSelectStreaming(p)}>
                                                {selectedStreaming?.id === p.id ? "Plano Selecionado" : "Assinar " + p.nome}
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                    </div>
                    )}
                    <div className="plans-container">
                        <div className="plans-header">
                            <b>Aproveite nossos planos <br />de telefonia móvel 2KMÓVEL!</b>
                        </div>
                        <div className="plans-grid">
                            {plansTelefoniaMovel.map((p) => {
                                const [precoInt, precoDec] = p.valor.toFixed(2).split(".");
                                const className = p.nome.includes('Total') || p.nome.includes('15GB') || p.nome.includes('30GB') || p.nome.includes('50GB') || p.nome.includes('Mais') ? 'purple' : '';
                                return (
                                    <div className={`plan-element ${className}`} key={p.nome}>
                                        <img src={planMovelImg} className="plan-logo" alt="plan logo" />
                                        <div className="potency-wrapper">
                                            <span>{p.nome.split(" ")[0]} </span>
                                            <span>{p.nome.split(" ")[1]}</span>
                                        </div>
                                        <div className="price-wrapper">
                                            <span>R$</span>
                                            <span className="price-dest">{precoInt}</span>
                                            <span className="price-small">,{precoDec}</span>
                                            <span className="month">/mês</span>
                                        </div>

                                        <div className="benefits-wrapper">
                                            {p.serv_ad.map((b) => (
                                                <div className="benefit-row" key={b.nome}><span>{b.nome}</span></div>
                                            ))}
                                        </div>

                                        <div className="button-wrapper">
                                            <button
                                                className="telefonia-plan-button"
                                                data-plan-name={p.nome}
                                                data-plan-price={precoInt}
                                                onClick={() => handleSelectMovel(p)}>
                                                {selectedMovel?.id === p.id ? "Plano Selecionado" : "Assinar " + p.nome}
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <div className="plans-container">
                        <div className="plans-header">
                            <b>Aproveite nossos planos <br />de telefonia 2KFIXO</b>
                        </div>

                        <div className="plans-grid">
                            {plansTelefoniaFixa.map((p) => {
                                const [precoInt, precoDec] = p.valor.toFixed(2).split(".");
                                const className = p.nome.includes('Total') || p.nome.includes('15GB') || p.nome.includes('30GB') || p.nome.includes('50GB') || p.nome.includes('Mais') ? 'purple' : '';
                                return (
                                    <div className={`plan-element ${className}`} key={p.nome}>
                                        <img src={planLivreImg} className="plan-logo" alt="plan logo" />
                                        <span>{p.nome}</span>
                                        <div className="price-wrapper">
                                            <span>R$</span>
                                            <span className="price-dest">{precoInt}</span>
                                            <span className="price-small">,{precoDec}</span>
                                            <span className="month">/mês</span>
                                        </div>

                                        <div className="benefits-wrapper">
                                            {p.serv_ad.map((b) => (
                                                <div className="benefit-row" key={b.nome}><span>{b.nome}</span></div>
                                            ))}
                                        </div>

                                        <div className="button-wrapper">
                                            <button
                                                data-plan-name={p.nome}
                                                data-plan-price={precoInt}
                                                onClick={() => handleSelectFixa(p)}>
                                                {selectedFixa?.id === p.id ? "Plano Selecionado" : "Assinar Plano"}
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </>
            )}


        </React.Fragment>
    );
};

export default Plans;